import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function SignInLink(): JSX.Element {
  const [t, { language }] = useTranslation();

  return (
    <p>
      {`${t('forms.already_have_account')} `}
      <Link to={`/${language}`}>{t('forms.sign_in')}</Link>
    </p>
  );
}
